<template>
    <div class="d-flex">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div
            class="modal-call"
            v-if="
                (plan.name === 'ArtistFree' && paymentMethods.length) ||
                (plan.name === 'VenueFree' && paymentMethods.length)
            "
        >
            <div class="downgrade-modal">
                <div class="modal-wrapper">
                    <div class="top-info">
                        <span class="hold-up">Hold up, think twice!</span>
                        <span class="modal-text"
                            >By downgrading, you're missing out on some serious perks! Limited
                            Booking Manager, no direct artist invites, no promotion tools and
                            so much more.</span
                        >
                    </div>
                    <div class="bottom-info">
                        <button class="call-to-action" @click="hideModal">
                            Nah, let’s keep my subscription plan
                        </button>
                        <div class="downgrade-action" @click="createSubscription">
                            <span>Sure, I’ll take the basic version for now</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="payment-modal-container" v-else>
            <div class="payment-modal-wrapper">
                <header class="payment-modal-header">
                    <p class="header-trial">Activate your free trial</p>
                    <p class="header-text">
                        Now let's add payment details to share your event with the talent pool
                    </p>
                    <p class="header-text">
                        Experience Hedlyner risk-free with our one-month free trial! Unlock
                        premium features, explore a diverse range of talented artists or invite
                        your favorites. Start transforming your live music bookings today!
                    </p>
                </header>
                <main class="payment-modal-main">
                    <div v-if="paymentMethods.length" class="view-cards">
                        <p class="title">Your cards</p>
                        <div class="payment-methods">
                            <div
                                v-for="(pm, indx) in paymentMethods"
                                :key="indx"
                                :style="{
                                    border:
                                        indx === selectedCardIndex
                                            ? '1px solid #CDEB09 !important'
                                            : ''
                                }"
                                class="payment-method"
                            >
                                <input
                                    type="radio"
                                    name="selectCard"
                                    :checked="pm.favourite"
                                    @click="handleSelectPm(indx, pm)"
                                />
                                <div class="card-info">
                                    <div class="first-row">
                                        <p class="card-info-grey">
                                            {{ pm.brand }} ending in &nbsp;
                                        </p>
                                        <p class="card-info-white">{{ pm.last_four }}</p>
                                    </div>
                                    <div class="second-row">
                                        <p class="card-info-grey">Expiry &nbsp;</p>
                                        <p class="card-info-white">{{ cardExp(pm) }}</p>
                                    </div>
                                </div>
                                <div class="card-brand">
                                    <img :src="brandIcon(pm)" :alt="pm.brand" />
                                </div>
                            </div>
                        </div>
                        <button @click="handleCancelAddCard" class="add-cards-btn">
                            Add new card
                        </button>
                    </div>
                    <div class="add-cards" v-if="!paymentMethods.length || showCardDetails">
                        <p class="title">Card details</p>
                        <div class="card-details-first-row">
                            <div class="card-holder-input">
                                <label for="cardholderName">Card holder *</label>
                                <input
                                    type="text"
                                    v-model="cardInfo.cardholderName"
                                    @input="validationCardHolder()"
                                    placeholder="Enter the card holder’s full name"
                                    :class="{
                                        'error-field': validateRules.cardholderName,
                                        'input-border': !validateRules.cardholderName
                                    }"
                                    required
                                />
                            </div>
                            <div class="card-exp-input">
                                <label for="exp_date">Exp Date*</label>
                                <input
                                    ref="cardExpDate"
                                    type="text"
                                    v-mask="'##/##'"
                                    @input="validationExpDate()"
                                    v-model="cardInfo.expDate"
                                    placeholder="Exp Date *"
                                    :class="{
                                        'error-field': validateRules.expDate,
                                        'input-border': !validateRules.expDate
                                    }"
                                    required
                                />
                            </div>
                        </div>
                        <div class="card-details-second-row">
                            <div class="card-number-input">
                                <label for="cardNumber">Card number*</label>
                                <input
                                    v-model="cardInfo.cardNumber"
                                    @keyup.delete="checkCard = false"
                                    type="text"
                                    @input="validationCardNumber()"
                                    maxlength="25"
                                    v-mask="'#### #### #### #### ###'"
                                    @blur="getLastFour()"
                                    ref="cardNumber"
                                    name="cardNumber"
                                    placeholder="Enter your card number"
                                    :class="{
                                        'error-field': validateRules.cardNumber,
                                        'input-border': !validateRules.cardNumber
                                    }"
                                />
                            </div>
                            <div class="card-cvc-input">
                                <label for="cvc">CVC*</label>
                                <input
                                    ref="cvc"
                                    @input="validationCVC()"
                                    v-mask="'####'"
                                    v-model="cardInfo.cvc"
                                    type="text"
                                    placeholder="CVC *"
                                    :class="{
                                        'error-field': validateRules.cvc,
                                        'input-border': !validateRules.cvc
                                    }"
                                    required
                                    data-testid="cvc-input"
                                />
                            </div>
                        </div>
                        <p v-if="this.checkCard" class="error-exist">
                            This card is already exist
                        </p>
                        <div class="card-actions">
                            <button @click="handleCancelAddCard" class="cancel-btn">
                                Cancel
                            </button>
                            <button
                                @click="handleSaveAddCard"
                                class="save-btn"
                                :disabled="!allFiledsCompeted"
                                :class="{ 'save-correct': !allFiledsCompeted }"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </main>
                <footer class="payment-modal-footer">
                    <p @click="hideModal">Subscriptions plans</p>
                    <button
                        class="subscribe-btn"
                        :class="{ 'disable-btn': showCardDetails || !this.selectCard }"
                        @click="createSubscription"
                        :disabled="showCardDetails || !this.selectCard"
                    >
                        Subscribe
                    </button>
                    <p class="cancel-btn" @click="hideModal">Cancel</p>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { SubMixin } from '../../../mixins/subscription/subscriptions'
    import { notification } from '@/helpers/notification'
    import { creditCardsValidation } from '../../../mixins/credit-card-validation'

    const URLS = {
        xhr: {
            fetch: {
                payment: '/profile/payment-details/all'
            },
            mutate: {
                payment: '/profile/payment-details/new'
            }
        },
        icons: {
            'American Express': '/images/icons/payment-details/cc-amex.svg',
            Visa: '/images/icons/payment-details/cc-visa.svg',
            MasterCard: '/images/icons/payment-details/cc-mastercard.svg',
            Discover: '/images/icons/payment-details/cc-discover.svg',
            UnionPay: '/images/icons/payment-details/UnionPay.svg',
            DinaCard: '/images/icons/payment-details/DinaCard.svg',
            'Diners Club': '/images/icons/payment-details/DinersClub.svg',
            BCCard: '/images/icons/payment-details/BCCard.svg',
            JCB: '/images/icons/payment-details/JSB.svg',
            others: '/images/icons/payment-details/cc-regular.svg'
        }
    }
    export default {
        name: 'PaymentModal',

        mixins: [SubMixin, creditCardsValidation],
        props: {
            plan: {
                type: Object
            },
            role: {
                type: String
            },
            mode: {
                type: String
            }
        },
        data: () => ({
            load: false,
            selectedCardIndex: null,
            paymentMethods: [],
            showCardDetails: false,
            cardId: null,
            selectedPlan: {},
            selectCard: false
        }),
        computed: {
            URLS: () => URLS,
            allFiledsCompeted() {
                return (
                    this.validationPass(this.validateRules) &&
                    this.cardInfo.cardholderName.length &&
                    this.cardInfo.cardNumber.length &&
                    this.cardInfo.cvc &&
                    this.cardInfo.expDate.length
                )
            },
            cardExp: () => (card) => {
                return `${card.exp_month}/${card.exp_year % 100}`
            },
            brandIcon: (self) => (card) => self.URLS.icons[card.brand],
            selectCircleStyle: () => (card) =>
                card.selected ? { border: '1px solid #CDEB09 !important' } : {},
            inputBrand: (self) => {
                let firstDig = self.cardInfo.cardNumber[0]
                if (!firstDig) return ''
                switch (firstDig) {
                    case '3':
                        return 'American Express'
                    case '4':
                        return 'Visa'
                    case '5':
                        return 'MasterCard'
                    case '6':
                        return 'Discover'
                    default:
                        return 'Other'
                }
            }
        },
        methods: {
            defaultSelected() {
                const defaultCardIndex = this.paymentMethods.findIndex((pm) => pm.favourite)
                if (defaultCardIndex !== -1) {
                    this.handleSelectPm(
                        defaultCardIndex,
                        this.paymentMethods[defaultCardIndex]
                    )
                }
            },
            selectFavouriteCard(paymentArr) {
                const favPayment = paymentArr.find((pm) => pm.favourite === 1)
                if (
                    favPayment &&
                    !this.hasPaymentExpired(favPayment.exp_month, favPayment.exp_year)
                ) {
                    return favPayment.card_stripe_id
                } else return
                //@TODO Dastan write that logic whenewer user haven`t favourite payment method will
                // be created in separate ticket
            },
            hasPaymentExpired(expMonth, expYear) {
                if (expYear.length === 2) expYear = '20' + expYear
                return new Date() > new Date(expYear, expMonth)
            },
            validationExistCard(payments) {
                if (this.cardInfo.last_four) {
                    this.checkCard = payments.some(
                        (card) => card.last_four === this.cardInfo.last_four
                    )
                }
                return this.checkCard
            },
            hideModal() {
                this.$emit('hideModal')
            },
            createSubscription() {
                this.load = true
                axios
                    .post('/profile/subscriptions/subscribe', {
                        plan: this.plan,
                        paymentMethod: this.cardId
                            ? this.cardId
                            : this.selectFavouriteCard(this.paymentMethods),
                        name: this.role
                    })
                    .then((response) => {
                        if (response.status === 200 && this.mode) {
                            this.$emit('goToEventPage')
                        } else {
                            window.location.reload()
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        this.errorText = 'You already have this subscription.'
                    })
                    .finally(() => {
                        this.load = false
                    })
            },
            async initPaymentMethods() {
                try {
                    let resp = await axios.get(this.URLS.xhr.fetch.payment)
                    this.paymentMethods = resp.data
                    this.initSelected()
                    this.defaultSelected()
                } catch (e) {
                    console.error(e)
                    notification('error', e)
                } finally {
                    this.load = false
                }
            },
            initSelected() {
                for (let i = 0; i < this.paymentMethods.length; i++) {
                    this.$set(this.paymentMethods, i, {
                        ...this.paymentMethods[i],
                        selected: false
                    })
                }
            },
            async handleSaveAddCard() {
                let postData = this.prepCardData()
                if (
                    this.validationPass(this.validateRules) &&
                    !this.validationExistCard(this.paymentMethods)
                ) {
                    try {
                        this.load = true
                        await axios.post(this.URLS.xhr.mutate.payment, postData)
                        await this.addSavedCard()
                    } catch (e) {
                        notification('error', e)
                    } finally {
                        this.load = false
                    }
                }
            },
            handleCancelAddCard() {
                this.showCardDetails = !this.showCardDetails
                for (const key of Object.keys(this.cardInfo)) {
                    this.cardInfo[key] = ''
                }
            },
            getIcon() {
                return '/images/'
            },
            handleSelectPm(index, card) {
                this.selectCard = true
                this.selectedCardIndex = index
                this.cardId = card.card_stripe_id
            },
            async addSavedCard() {
                this.paymentMethods.splice(0)
                this.clearFormValues()
                await this.initPaymentMethods()
                this.showCardDetails = false
            },
            clearFormValues() {
                for (const key of Object.keys(this.cardInfo)) {
                    this.cardInfo[key] = ''
                }
            },
            prepCardData() {
                let name = this.cardInfo.cardholderName.split(' ')
                let firstName = name[0]
                let lastName = name[1]
                let cardNumber = this.prepareCardNumber(this.cardInfo.cardNumber)
                let data = {
                    nickname: firstName,
                    cardholder_name: this.cardInfo.cardholderName,
                    card_number: cardNumber,
                    exp_date: this.cardInfo.expDate,
                    cvc: this.cardInfo.cvc,
                    first_name: firstName,
                    last_name: lastName
                }
                return data
            }
        },
        async created() {
            await this.initPaymentMethods()
        }
    }
</script>
<style lang="scss" scoped>
    input[type='radio'] {
        height: 20px;
        width: 20px;
        background: inherit;
        appearance: none;
        border: 1px solid #8b8b8b;
        border-radius: 50%;
    }
    input[type='radio']:checked {
        accent-color: #cdeb09;
        appearance: auto;
    }
    .modal-call {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 120;
    }
    .downgrade-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 25;
    }
    .modal-wrapper {
        display: inline-flex;
        padding: 48px 80px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 48px;
        border-radius: 15px;
        background: #262626;
        z-index: 121;
    }
    .top-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
    .hold-up {
        color: #f5f5f5;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .modal-text {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .bottom-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }
    .call-to-action {
        display: flex;
        align-self: stretch;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cdeb09;
        min-width: 600px;
        border: 0;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .downgrade-action {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #8b8b8b;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }

    .disable-btn {
        opacity: 0.5;
    }
    .error-exist {
        color: #ca2121;
    }
    .add-cards-btn {
        padding: 12px 16px;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .payment-modal-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        width: 100%;
    }
    .payment-modal-footer p {
        color: #acacac;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        cursor: pointer;
    }
    .subscribe-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        width: 100%;
        border: 0;
    }
    .header-text {
        color: #acacac;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .header-trial {
        color: #f5f5f5;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .payment-modal-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        height: 100vh;
        width: 100vw;
        background: rgba(22, 22, 22, 0.92);
        top: 0;
        left: 0;
        padding: 80px 0;
        z-index: 121;
        p {
            margin-bottom: 0px;
        }
        .payment-modal-wrapper {
            max-width: 585px;
            height: fit-content;
            background: #262626;
            border-radius: 24px;
            position: sticky;
            bottom: 0;
            padding: 48px 80px;
            display: flex;
            flex-direction: column;
            gap: 48px;
            align-items: center;
            max-height: 750px;
            overflow-y: scroll;
            .payment-modal-header {
                display: flex;
                flex-direction: column;
                gap: 20px;
                align-items: center;
            }
            .payment-modal-main {
                display: flex;
                flex-direction: column;
                gap: 24px;
                align-items: center;
                .title {
                    color: #dedede;
                    font-family: Instrument Sans;
                    font-size: 26px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                }
                .view-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    justify-content: center;
                    .payment-methods {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                        justify-content: center;
                        .payment-method {
                            position: relative;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            gap: 16px;
                            padding: 16px;
                            border-radius: 15px;
                            border: 1px solid #8b8b8b;
                            min-width: 425px;
                            .circle {
                                cursor: pointer;
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                background: none;
                                border: 1px solid #8b8b8b;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                            .card-info {
                                display: flex;
                                flex-direction: column;
                                gap: 4px;
                                align-items: flex-start;
                                .first-row,
                                .second-row {
                                    display: flex;
                                    flex-direction: row;
                                    gap: 0px;
                                    p {
                                        font-family: Instrument Sans;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 700;
                                        line-height: 130%;
                                        letter-spacing: 0.14px;
                                    }
                                    .card-info-white {
                                        color: #f5f5f5;
                                    }
                                    .card-info-grey {
                                        color: #acacac;
                                    }
                                }
                            }
                            .card-brand {
                                margin-left: auto;
                                width: 46px;
                                height: 32px;

                                img {
                                    width: 46px;
                                    height: 32px;
                                }
                            }
                            .selector {
                                background: #cdeb09;
                                width: 10px;
                                height: 10px;
                                border-radius: 50%;
                            }
                        }
                    }
                }
                .add-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    align-items: center;
                    .card-details-first-row,
                    .card-details-second-row {
                        display: flex;
                        flex-direction: row;
                        gap: 12px;
                        .card-holder-input,
                        .card-exp-input,
                        .card-number-input,
                        .card-cvc-input {
                            display: flex;
                            flex-direction: column;
                            gap: 6px;
                            label {
                                color: #8b8b8b;
                                font-family: Instrument Sans;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 650;
                                line-height: 135%;
                                letter-spacing: 0.12px;
                            }
                            input {
                                padding: 12px 16px 16px 16px;
                                border-radius: 12px;
                                border: 1px solid #8b8b8b;
                                background: #262626;
                                color: #f5f5f5;
                                font-family: Instrument Sans;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 550;
                                line-height: 125%;
                            }
                            input::placeholder {
                                color: #646464;
                                font-family: Instrument Sans;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 550;
                                line-height: 125%;
                            }
                            .error-field {
                                border: 1px solid #ca2121;
                            }
                            .input-border {
                                border: 1px solid #ffffff63;
                            }
                        }
                        .card-holder-input,
                        .card-number-input {
                            input {
                                width: 300px;
                            }
                        }
                        .card-exp-input,
                        .card-cvc-input {
                            input {
                                width: 113px;
                            }
                        }
                    }
                    .card-actions {
                        display: flex;
                        flex-direction: row;
                        gap: 24px;
                        justify-content: center;
                        .cancel-btn {
                            background: none;
                            border: none;
                            color: #8b8b8b;
                            font-family: 'Studio Pro';
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 120%;
                            text-decoration-line: underline;
                            cursor: pointer;
                        }
                        .save-btn {
                            padding: 7px 30px 9px 30px;
                            background: #cdeb09;
                            border: 0;
                            border-radius: 100px;
                            color: #000;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 350;
                            line-height: 120%;
                            min-width: 96px;
                        }
                        .save-correct {
                            background: #646464;
                        }
                    }
                }
            }
        }
        .payment-modal-wrapper::-webkit-scrollbar {
            width: 0;
        }
    }
</style>
